var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`timeline-marker timeline-marker--${_vm.type}`},[_c('div',{staticClass:"timeline-marker-head",style:(_vm.headStyle)}),_c('div',{staticClass:"timeline-marker-tail",style:(_vm.tailStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }